/**
 * API key management — CRUD operations for Thread SDK keys.
 */

import { apiClient } from "./client";

export type ApiKeyScope =
  | "full"
  | "embed"
  | "agent"
  | "thread_read"
  | "thread_write"
  | "thread_import"
  | "thread_invalidate"
  | "bobbin_daily"
  | "bobbin_mobile";

export interface ApiKey {
  id: string;
  name: string;
  key_prefix: string | null;
  created_at: string;
  last_used_at: string | null;
  has_flow360_key: boolean;
  scope?: ApiKeyScope;
  project_id?: string | null;
  expires_at?: string | null;
}

export interface CreatedApiKey extends ApiKey {
  key_prefix: string;
  raw_key: string;
}

export interface CreateKeyPayload {
  name: string;
  flow360_api_key?: string;
  scope?: ApiKeyScope;
  project_id?: string;
}

export async function fetchApiKeys(): Promise<ApiKey[]> {
  return apiClient<ApiKey[]>("/auth/api-keys");
}

export async function createApiKey(
  payload: CreateKeyPayload,
): Promise<CreatedApiKey> {
  return apiClient<CreatedApiKey>("/auth/api-keys", {
    method: "POST",
    body: payload,
  });
}

export async function revokeApiKey(keyId: string): Promise<void> {
  await apiClient(`/auth/api-keys/${keyId}`, { method: "DELETE" });
}
